import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/twitter_blue.svg'
import _imports_1 from '@/assets/Contacts/members.png'


import { ref } from 'vue';
import copyToClipboard from 'quasar/src/utils/copy-to-clipboard.js';import openURL from 'quasar/src/utils/open-url.js';;
import TitleCard from '../utils/TitleCard.vue';
import ContactItem from './ContactItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const copied = ref(false)

function copyMailAddress() {
  copyToClipboard('hasumukaidm@gmail.com').then(() => {copied.value = true})
}

return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleCard, {
      title: "Contact",
      "sub-title": "お気軽にご連絡ください。",
      abst: ['斜向へのご相談などがございましたら、お気軽にご連絡ください。']
    }),
    _createVNode(_component_q_list, null, {
      default: _withCtx(() => [
        _createVNode(ContactItem, {
          title: "Twitter DM",
          caption: "@hsmkaiへのDMを開きます（表示に少々時間がかかります）",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openURL)('https://twitter.com/messages/1121761492284493824-1428274147663122432')))
        }, {
          avater: _withCtx(() => [
            _createVNode(_component_q_avatar, {
              square: "",
              size: "2rem"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_img, { src: _imports_0 })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ContactItem, {
          title: "電子メール",
          caption: "クリックするとメールアドレスをクリップボードへコピーします",
          onClick: copyMailAddress
        }, {
          avater: _withCtx(() => [
            _createVNode(_component_q_icon, {
              size: "2rem",
              color: "primary",
              name: "mail"
            })
          ]),
          side: _withCtx(() => [
            _withDirectives(_createVNode(_component_q_icon, {
              name: "assignment_turned_in",
              color: "green",
              size: "1.5rem"
            }, null, 512), [
              [_vShow, copied.value]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_img, {
      src: _imports_1,
      class: "q-ma-lg",
      style: {"width":"min(800px, 85%)"}
    })
  ], 64))
}
}

})